export default function OwnerPayments() {
  return (
    <>
      <div className="main">
        <div className="topbar">
          <div>
            <div className="page-title" id="page-title">
              Payments
            </div>
            <div className="page-sub" id="page-sub">
              Payment tracking
            </div>
          </div>
          <div className="topbar-right" id="topbar-right" />
        </div>
        <div className="content" id="content-area">
          <div className="card">
            <div className="card-title">Payments</div>
            <p className="muted" style={{ fontSize: 13 }}>
              This module is fully available in the complete build.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
